import { useEffect, useState } from 'react';

const read = () =>
  document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';

export const useResolvedTheme = () => {
  const [theme, setTheme] = useState(read);

  useEffect(() => {
    const observer = new MutationObserver(() => setTheme(read()));
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });
    return () => observer.disconnect();
  }, []);

  return theme;
};
